// src/components/PageEditor.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import "./PageEditor.css"; // Custom CSS for styling

const PageEditor = () => {
  const [pages, setPages] = useState([
    "privacy",
    "terms",
    "contact",
    "return",
    "about",
  ]);
  const [selectedPage, setSelectedPage] = useState("privacy");
  const [content, setContent] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchPage = async (page) => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_URL}/pages/${page}`);
      setContent(res.data.content);
      setLoading(false);
    } catch (err) {
      setContent("");
      setLoading(false);
      setMessage("Error fetching page!");
    }
  };

  useEffect(() => {
    fetchPage(selectedPage);
  }, [selectedPage]);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      await axios.put(`${process.env.REACT_APP_URL}/pages/${selectedPage}`, {
        content,
      });
      setMessage("Page updated successfully!");
      setLoading(false);
    } catch (err) {
      setMessage("Error updating page!");
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5 page-editor-container">
      <Row className="mb-3">
        <Col md={4}>
          <Form.Select
            value={selectedPage}
            onChange={(e) => setSelectedPage(e.target.value)}
          >
            {pages.map((p) => (
              <option key={p} value={p}>
                {p.charAt(0).toUpperCase() + p.slice(1)}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={8}>
          <Button onClick={handleUpdate} className="btn-update">
            {loading ? "Updating..." : "Update Page"}
          </Button>
        </Col>
      </Row>

      {message && <Alert variant="info">{message}</Alert>}

      <CKEditor
        editor={ClassicEditor}
        data={content}
        onChange={(event, editor) => {
          const data = editor.getData();
          setContent(data);
        }}
      />
    </Container>
  );
};

export default PageEditor;
